module.exports = __webpack_public_path__ + "static/img/case.2222bb38.png";